module.exports = __webpack_public_path__ + "static/flags/MA-85b70479e36ac0c565e13d2c74de6c9d.gif";